import React from 'react';
import { TableAddress } from './TableAddress';
import { useViewPort } from '../Hooks/useViewPort';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { GdacsTimeline } from "../Layout/GdacsTimeline";

const AddressContainer = (props) => {
    const [addresses, setAddresses] = React.useState(props.params.addresses);
    const { width } = useViewPort();
    const breakpoint = 620;
    const [navIndex, setNavIndex] = React.useState(props.navIndex);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);


    const handleChangeAddress = (addresses) => {
        props.onChange("addresses", addresses);

    }

    const handleChangeButton = (isButtonDisabled) => {
        props.isButtonDisabled(isButtonDisabled);
    }

    React.useEffect(() => {
        props.onChange(addresses);
        props.isButtonDisabled(isButtonDisabled);
    }, [addresses, isButtonDisabled]);

    return (<div>
        <h4 className="d-flex justify-content-center hr-title">Enter Addresses</h4>
        <br />
        {width > breakpoint &&
            <GdacsTimeline navIndex={navIndex} user={props.params.idUser} />

        }

        {width < breakpoint &&
            <>
                {props.params.idUser === 0 &&
                    <ProgressBar>
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} />
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} label={3} />
                    </ProgressBar>
                }
                {props.params.idUser !== 0 &&
                    <ProgressBar>
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={25} label={2} />
                    </ProgressBar>
                }
            </>
        }
        <br />
        <br />
        <div className="p_summary">To receive notifications as email, SMS or APP notify messages, please enter the appropriate number or address.<br />
            (For SMS please specify max 5 numbers, for APP service click only the button Add)</div>
        <br />
        <TableAddress params={props.params} onChange={handleChangeAddress} isButtonDisabled={handleChangeButton} />
        <br />
    </div>)
}
export { AddressContainer }